import { forwardRef, Icon, Input, InputGroup, InputProps, InputRightElement } from '@chakra-ui/react';

import SearchIcon from '@/assets/icons/ic-search.svg';

type IComboboxProps = InputProps;

export const ComboboxInput = forwardRef<IComboboxProps, 'input'>((props, ref) => {
  return (
    <InputGroup px={2} my={2}>
      <Input pr={10} variant="flushed" {...props} ref={ref} />
      <InputRightElement pl={0} pr={4} minW="max-content">
        <Icon as={SearchIcon} color="black" boxSize="24px" />
      </InputRightElement>
    </InputGroup>
  );
});
